import { Container, Typography, Box, Grid } from '@mui/material';
import { getImageUrl } from '../../utils';
import { CenterFocusStrong } from '@mui/icons-material';

const Section = ({ children }) => (
  <Box
    sx={{
      py: { xs: 4, md: 6 },
      px: { xs: 2, md: 4 },
      mb: { xs: 4, md: 6 },
    }}
  >
    {children}
  </Box>
);

const instructorData = {
  sandra: {
    name: 'Sandra Möller',
    imageUrl: 'about-sandra3.png',
    description: `Sandra är certifierad Teacher Trainer och har utbildat sig både hos Power Pilates och The Pilates Standard. Hon blev kär i pilates när det hjälpte henne bli smärtfri och starkare – något hon nu delar vidare med varje kund.`,
    certifications: `Certifierad Teacher Trainer • TRX-instruktör • BALLance-instruktör • Functional Trainer • C-tränare hästhoppning`,
  },
  agnes: {
    name: 'Agnes Knutsson',
    imageUrl: 'about-agnes3.png',
    description: `Agnes hittade pilates efter ryggproblem och blev snabbt fascinerad. Hennes mål är att sprida träningsglädje och kroppskännedom till andra.`,
    certifications: `Certifierad Pilatesinstruktör (matta + apparat) • TRX & BALLance-instruktör`,
  },
  johanna: {
    name: 'Johanna Magnelin',
    imageUrl: 'about-johanna3.png',
    description: `Johanna ser pilates som en lagsport där alla hejar på varandra. Hon är prestigelös, energifylld och brinner för att skapa trygg träning.`,
    certifications: `Certifierad Comprehensive Pilates Teacher • BALLance-instruktör`,
  },
  malin: {
    name: 'Malin Heimdahl',
    imageUrl: 'about-malin3.png',
    description: `Med en bakgrund inom yoga blandar Malin energigivande rörelse med balans och glädje. Hon följer lusten och hittar variation i träningen.`,
    certifications: `Certifierad Yogalärare • TRX • Gravidyoga • BALLance • Pilates under utbildning`,
  },
  jennie: {
    name: 'Jennie Levin',
    imageUrl: 'about-jennie3.png',
    description: `Jennie är morgonpigg, energisk och älskar variation. Hon inspirerar andra till hållbar träning – med skratt, styrka och rörelse.`,
    certifications: `TRX-instruktör • Pilatesinstruktör • BodyPump (Les Mills) • Tabata, Core, Bootymove`,
  },
};

const AboutInfo = () => (
  <Container sx={{ pt: { xs: 4, md: 8 }, pb: 6 }}>
    <Typography
      variant="h3"
      align="center"
      sx={{
        fontWeight: 'bold',
        color: '#007C85',
        mb: { xs: 4, md: 6 },
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
      }}
    >
      Om Pilates Höganäs
    </Typography>

    <Section>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6} sx={{ margin:'0 auto'}}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#007C85', textAlign:'center' }}>
            Varför Träna Pilates?
          </Typography>
          <Grid item xs={12} md={6}>
         
        </Grid>
          <Typography variant="body1" sx={{ lineHeight: 1.8, color: '#555', textAlign:'center' }}>
            Pilates är en fantastisk träningsform som stärker kärnmuskulaturen, förbättrar
            flexibiliteten och främjar en sund kroppshållning. Det är en skonsam men effektiv träning
            som passar alla, oavsett ålder eller fysisk kondition.
          </Typography>
        </Grid>
        
      </Grid>
    </Section>

    <Section>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src={getImageUrl('stud.png')}
            alt="Pilates Studio Interior"
            sx={{
              width: '100%',
              maxWidth: 500,
              mx: 'auto',
              borderRadius: '16px',
              boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#007C85' }}>
            Vår Studio
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8, color: '#555' }}>
            Vi har nyligen flyttat till en ny och större studio. Här möts du av en modern men mysig
            atmosfär med glänsande utrustning, tränare som är både utbildade och roliga, och klasser
            som passar alla nivåer. Vi erbjuder också PT-pass för dig som vill ha extra fokus.
            <br></br>
            <br></br>
            Pilates Höganäs är ditt andra hem. Vår studio har en vacker och inbjudande inredning där
            du kan stanna kvar efter träning, ta en kopp kaffe och njuta av atmosfären. Vi ligger nu
            i padelhallen – perfekt för att kombinera träning och mat!
          </Typography>
        </Grid>
      </Grid>
    </Section>

    <Section>
      
      <Grid container spacing={2} mt={4}>
        {['stud2.png', 'stud3.png', 'stud4.png', 'stud5.png'].map((img, i) => (
          <Grid item xs={6} sm={3} key={i}>
            <Box
              component="img"
              src={getImageUrl(img)}
              alt={`Studio ${i + 1}`}
              sx={{
                width: '100%',
                borderRadius: '12px',
                boxShadow: '0 4px 10px rgba(0,0,0,0.06)',
                transition: 'transform 0.3s',
                '&:hover': { transform: 'scale(1.03)' },
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Section>

    <Section>
      <Typography variant="h4" align="center" gutterBottom sx={{ color: '#007C85', mb: 4 }}>
        Våra Instruktörer
      </Typography>
      {Object.keys(instructorData).map((key, i) => {
        const instructor = instructorData[key];
        const imageLeft = i % 2 === 0;

        return (
          <Grid
            key={key}
            container
            spacing={4}
            alignItems="center"
            direction={imageLeft ? 'row' : 'row-reverse'}
            sx={{ mb: 6 }}
          >
            <Grid item xs={12} md={4}>
              <Box
                component="img"
                src={getImageUrl(instructor.imageUrl)}
                alt={instructor.name}
                sx={{
                  width: '100%',
                  maxWidth: 400,
                  mx: 'auto',
                  borderRadius: '16px',
                  boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
                }}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#007C85', mb: 1 }}>
                {instructor.name}
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, color: '#555', whiteSpace: 'pre-line' }}>
                {instructor.description}
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontStyle: 'italic', whiteSpace: 'pre-line', color: '#666' }}
              >
                {instructor.certifications}
              </Typography>
            </Grid>
          </Grid>
        );
      })}
    </Section>

    <Section>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#007C85' }}>
            Var Finns Vi?
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8, color: '#555' }}>
            Du hittar oss på Litteraturvägen 4A, 263 35 Höganäs. Vår studio ligger centralt med bra
            parkeringsmöjligheter och nära kollektivtrafik.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d21249.472897457284!2d12.5511461!3d56.1923911!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465265f45b9b483d%3A0xe1f3e5bbf235a1e2!2sLitteraturv%C3%A4gen%204A%2C%20263%2035%20H%C3%B6gan%C3%A4s%2C%20Sweden!5e0!3m2!1sen!2sse!4v1632992896581!5m2!1sen!2sse"
            width="100%"
            height="400"
            style={{
              border: 'none',
              borderRadius: '16px',
              boxShadow: '0 8px 16px rgba(0,0,0,0.08)',
            }}
            allowFullScreen
            loading="lazy"
            title="Studio Location"
          ></iframe>
        </Grid>
      </Grid>
    </Section>
  </Container>
);

export default AboutInfo;
